module.exports = __webpack_public_path__ + "media/images/game/resources/chechtaky-f5e380c8858ca456c08b660c2d74ae4f.png";